<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="soas"
        @select="selectHandle"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle"
        @reset="resetHandle">
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.subAuth" :loading="submitLoading" :disabled="scope.row.status !==0" type="primary" @click="submit(scope.row)">提交</el-button>
<!--        <el-button type="primary" @click="createInvoice(scope.row)">开票</el-button>-->
<!--        <el-button type="danger" @click="cancelInvoice(scope.row)">冲销开票</el-button>-->
      </template>>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="对账单号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入对账单号" clearable/>
          </el-form-item>
          <el-form-item label="送货单号">
            <el-input v-model.trim="filter.purchaseReceiveNo" placeholder="请输入送货单号" clearable/>
          </el-form-item>
          <el-form-item label="采购单号">
            <el-input v-model.trim="filter.sapPurchaseOrderNo" placeholder="请输入采购单号" clearable/>
          </el-form-item>
          <el-form-item label="供应商编号">
            <el-input v-model.trim="filter.supplierNo" placeholder="请输入供应商编号" clearable/>
          </el-form-item>
          <el-form-item label="供应商名称">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入供应商名称" clearable/>
          </el-form-item>
          <el-form-item label="采购组">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购组" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.statusName" clearable placeholder="请选择状态">
              <el-option label="全部" value=""/>
              <el-option label="草稿" value="草稿"/>
              <el-option label="财务确认发票信息" value="财务确认发票信息"/>
              <el-option label="采购确认发票信息" value="采购确认发票信息"/>
              <el-option label="采购确认开票申请" value="采购确认开票申请"/>
              <el-option label="供应商开票" value="供应商开票"/>
              <el-option label="已完成" value="已完成"/>
            </el-select>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="filter.consignment" clearable placeholder="请选择类型">
              <el-option label="全部" value=""/>
              <el-option label="非寄售" value="非寄售"/>
              <el-option label="寄售" value="寄售"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </viewtable>
    <reconcile-order-edit ref="reconcileOrderEdit" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import ReconcileOrderEdit from "@/views/PurchaseOrderManager/ReconcileOrder/ReconcileOrderEdit";

  export default {
    name:"ReconcileOrderList",
    components: {ReconcileOrderEdit, viewTable},
    data() {
      return {
        limits: {
          editAuth: this.$auth(452),
          delAuth: this.$auth(454),
          subAuth: this.$auth(453),
        },
        filter: {
          billNo: "",
          supplierName: "",
          supplierNo: "",
          status: "",
          statusName:"",
          purchaseReceiveNo:"",
          sapPurchaseOrderNo:"",
          buyUserName:"",
          consignment:"",
        },
        selection: [],
        arriveDate:"",
        createDate:"",
        submitLoading:false,
        columnsProperty: [
          {
          tooltip: true,
            key: "billNo",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$router.push({
                        path: "/ReconcileOrderDetail",
                        query: {
                          billType: 27,
                          billId: params.row.pkId,
                          sequId: -1,
                          $tabName: params.row.billNo,
                        },
                      });
                    },
                  },
                },
                params.row.billNo,
              );
            },
          },
          {
          tooltip: true,
            key: "asnRowIndex",
            width: 120,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 300,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    mounted() {
    },

    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },

      addEditHandle(row) {
        this.$refs.reconcileOrderEdit.open(1,row);
      },

      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      deleteHandle(row) {
        console.log(row);
        this.$http.delete("basic", "soas", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },

      arriveDateChange(value) {
        if (value) {
          this.filter.arriveDateBegin = value[0];
          this.filter.arriveDateEnd = value[1];
        } else {
          this.filter.arriveDateBegin = "";
          this.filter.arriveDateEnd = "";
        }
      },

      createDateChange(value) {
        if (value) {
          this.filter.createDateBegin = value[0];
          this.filter.createDateEnd = value[1];
        } else {
          this.filter.createDateBegin = "";
          this.filter.createDateEnd = "";
        }
      },

      submit(row) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.submitLoading = true;
          this.$http.post("basic", `soas/submit/${row.pkId}`).then((res) => {
            if (res.success) {
              this.submitLoading = false;
              this.$message.success("提交成功");
              this.loadData();
            }
          }).catch(()=>{
            this.submitLoading = false;
          });
        });
      },

      createInvoice(row) {
        this.$http.get("basic", `soas/createInvoice/${row.pkId}`).then((res) => {
          if (res.success) {
            this.submitLoading = false;
            this.$message.success("开票成功");
            this.loadData();
          }
        }).catch(()=>{
          this.submitLoading = false;
        });
      },

      cancelInvoice(row) {
        this.$http.get("basic", `soas/cancelInvoice/${row.pkId}`).then((res) => {
          if (res.success) {
            this.submitLoading = false;
            this.$message.success("冲销成功");
            this.loadData();
          }
        }).catch(()=>{
          this.submitLoading = false;
        });
      },

      resetHandle(filter) {
        this.filter = filter;
      },

      //未提交、退单可以编辑删除
      otherAuth(row) {
        if (row.status === 0) {
          return  false;
        } else {
          return  true;
        }
      },
    },
  };
</script>
